import { render } from "./SimilarInteresting.vue?vue&type=template&id=3da82f7c&scoped=true"
import script from "./SimilarInteresting.vue?vue&type=script&lang=js"
export * from "./SimilarInteresting.vue?vue&type=script&lang=js"

import "./SimilarInteresting.vue?vue&type=style&index=0&id=3da82f7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da82f7c"]])

export default __exports__